import { JobAlertModalSearchParams } from './interfaces';

export type TransformedQueryParams = {
  token?: string;
  email?: string;
  isEmailEditable?: boolean;
  categories?: string[];
  timeType?: string[];
};

const transformQueryParams = (
  queryParams: JobAlertModalSearchParams
): TransformedQueryParams => {
  const token = queryParams.token;
  const email = queryParams.email;
  const categories = queryParams.categories?.split(',');
  const timeType = queryParams.timeType?.split(',');
  return {
    categories,
    timeType,
    email,
    token,
  };
};

export default transformQueryParams;
